import { ChangeDetectorRef, Component , ElementRef, Inject, Renderer2, ViewChild} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import config from 'config/default.json';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  constructor(
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any }
    ) {}
  projectNameControl = new FormControl();
  supplierControl = new FormControl();
  waveControl = new FormControl();
  supplierNameControl = new FormControl();
  supplierSearchControl = new FormControl();
  supplierDescriptionControl = new FormControl();
  phoneControl = new FormControl();
  contentAcquisitionControl = new FormControl();
  userWaves:any = [] = [];
  userInfos = this.data['user_infos'] || {};
  page:string = this.data['page'];
  suppliers: any[] = this.data?.['suppliers'] ?? [];
  projectName: string = this.data?.['product_name'] ?? '';
  isNewSupplier: boolean = false;
  supplierSelected: any = null;
  yearWave = new Date().getFullYear();

  
  //Connection As
  ngOnInit(){
    this.waveControl.setValue(new Date().getMonth() + 1);
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/load_waves', {}, this.userInfos['access_token']).subscribe((response:any)=>{
      this.userWaves = response;
    })
    this.projectNameControl.setValue(this.projectName);
    this.supplierSearchControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        console.log(query)
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })).subscribe((options) => {
      this.suppliers = options;
    });
    this.cdRef.detectChanges();
  }
  
  

  //Project Name
  validateAction(){
    this.sendBack(true);
  }
  sendProjectName(){
    this.sendBack({confirm: true, project_name: this.projectNameControl.value});
  }
  sendUploadValidation(){
    let idUserSupplier = this.supplierControl.value;
    let supplierWave = this.waveControl.value;
    let supplierName = this.supplierNameControl.value
    let supplierPhone = this.phoneControl.value;
    let supplierAcquisitionAmount = this.contentAcquisitionControl.value;
    let data = {
      id_user_supplier: idUserSupplier,
      id_supply_wave: supplierWave,
      year_supply_wave: this.yearWave,
      supplier_name: supplierName,
      supplier_description: this.supplierDescriptionControl.value,
      phone: supplierPhone,
      amount_acquisition: supplierAcquisitionAmount
    }
    if(idUserSupplier > 0 && supplierWave > 0) this.sendBack({confirm: true, ...data});
    else
      if(supplierName != '' && supplierPhone != '' && supplierAcquisitionAmount > 0)
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/raw-content/create_supplier', data, this.userInfos['access_token']).subscribe((response:any)=>{
        data.id_user_supplier = response.id;
        
        this.sendBack({confirm: true, ...data});
      });
    else this.helper.showToast("Some infos are empty...");
  }
  closeProjectCreation(){
    this.sendBack({confirm: false});
  }
  switchNewSupplier(userId: number){
    this.isNewSupplier = this.supplierControl.value == '0'? true: false;
    this.supplierSelected = this.suppliers.find(user => user.id === userId) || null;
  }
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9+]/g, '');

    value = value.replace(/\+/g, '');

    if (input.value.startsWith('+')) {
        value = '+' + value;
    }

    input.value = value;
    this.phoneControl.setValue(value, { emitEvent: false });
  }

  onClose(): void {
    this.sendBack(false);
  }
  sendBack(data:any){
    this.dialogRef.close(data);
  }

}
